export default __webpack_public_path__ + "static/media/caret_sx.53961dfa.svg";